/**
 * Negociações: member só vê deals com `agent === userId` (RLS + UI).
 * Sem responsável some para member — por isso criações forçam assigned_to do usuário.
 */

export function resolveLeadAgentForVisibility(
    requestedAgent: string | null | undefined,
    options: { userId: string | undefined; canViewAllLeads: boolean; defaultToCurrentUser?: boolean }
): string | null {
    const { userId, canViewAllLeads } = options;
    const raw = requestedAgent?.trim() ? String(requestedAgent).trim() : null;

    if (canViewAllLeads) {
        return raw;
    }

    if (!userId) {
        return raw;
    }

    // Member: sempre atribui a si se vazio ou de outro usuário
    if (!raw || raw !== userId) return userId;
    return raw;
}
